<template>
    <label
        class="kgr-inputGroup"
        :class="{ 'with-errors': errorMessage, 'kgr-inputGroup--inline': inline }"
    >
        <div
            v-if="label"
            class="kgr-inputGroup__label"
        >
            {{ label }}
            <template v-if="required">*</template>
        </div>

        <slot></slot>

        <div
            v-if="errorMessage"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ errorMessage }}
        </div>
        <div
            v-if="tooltip"
            class="kgr-inputGroup__text"
        >
            {{ tooltip }}
        </div>
    </label>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
        },
        tooltip: {
            type: String,
            required: false,
        },
        errorMessage: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            required: false,
        },
        inline: {
            type: Boolean,
            required: false,
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
